import React from "react";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { validate, validators, optional } from "validate-redux-form";
import { renderTextArea } from "../../Utils/renderField/renderField";
import { ListadoAccion } from "../../Utils/ListadoAccion";
import { DetalleAccion } from "../../Utils/DetalleAccion";
import { icons } from "icons";
import {
    formatoNombre,
    formatoExistencia,
    formatoAcciones,
    buscar,
    formatoProducto,
    formatoInventario,
    formatoCodigo,
    formatoEquivalente1,
} from "Utils/CamposComunes";

import { formatoReajuste } from "./CamposDetalle";

const Form = (props) => {
    const {
        loader,
        data,
        listar,
        sortChange,
        seleccionados,
        page,
        ver_buscador,
        cambio_buscador,
        agregar,
        producto_actual,
        setProductoActual,
    } = props;
    const { handleSubmit, actionAyuda, quitar } = props;
    const llavesListado = [
        {
            nombre: "producto__codigo",
            sort: true,
            caption: "Código",
            format: formatoCodigo,
            align: "left",
        },
        {
            nombre: "producto__nombre",
            sort: true,
            caption: "Nombre",
            format: formatoNombre,
            align: "left",
        },
        {
            nombre: "producto__codigo_equivalente",
            sort: true,
            caption: "Código equivalente",
            format: formatoEquivalente1,
            // align: "left",
        },
        {
            nombre: "inventario",
            sort: false,
            caption: "Existencias",
            // format: formatoExistencia,
            align: "left",
        },
        {
            nombre: "acciones",
            sort: false,
            caption: "Acciones",
            format: formatoAcciones(props),
            align: "center",
            width: "90px",
        },
    ];

    const llavesDetalle = [
        {
            nombre: "producto__codigo",
            sort: true,
            caption: "Código",
            format: formatoCodigo,
            // align: "left",
        },
        { caption: "Nombre", nombre: "producto", format: formatoProducto },
        {
            nombre: "producto__codigo_equivalente",
            sort: true,
            caption: "Código equivalente",
            format: formatoEquivalente1,
            // align: "left",
        },
        {
            caption: "Existencias en sistema",
            nombre: "existencias",
            format: formatoInventario,
            width: "160px",
            align: "right",
        },
        {
            caption: "Existencia real",
            nombre: "reajuste",
            format: formatoReajuste(props),
            width: "130px",
        },
    ];
    return (
        <form onSubmit={handleSubmit} className="row form-group">
            <div className="col-12 mb">
                <div className="grid-container d-flex flex-column">
                    <div className="form-group">
                        <label htmlFor="motivo">Motivo del reajuste</label>
                        <Field
                            name="motivo"
                            rows={2}
                            component={renderTextArea}
                            className="form-control w-100"
                        />
                    </div>
                </div>
            </div>
            <div className="slide-container row" style={{ margin: "0" }}>
                {/* //*** Listado de productos */}
                <div
                    className={`col-12 mb-4 mt-4 ${
                        ver_buscador ? "form-activo" : ""
                    } slide `}
                >
                    <ListadoAccion
                        buscar={buscar(props)}
                        loader={loader}
                        llaves={llavesListado}
                        data={data}
                        listar={listar}
                        sortChange={sortChange}
                        titulo={"Listado de Productos"}
                        page={page}
                    />
                    <div className="d-lg-none d-xl-none grid-container align-items-center mt0 padding-10 d-flex justify-content-around flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row">
                        <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={() => {
                                cambio_buscador();
                            }}
                        >
                            <img src={icons.cancelar} alt="" /> Cancelar
                        </button>
                    </div>
                </div>
                {/* //*** Listado de productos en reajuste */}
                <div
                    className={`col-12 ${
                        !ver_buscador ? "form-activo" : ""
                    } form-trasero`}
                >
                    <DetalleAccion
                        data={seleccionados}
                        titulo={"Lista de Productos en Reajuste"}
                        llaves={llavesDetalle}
                        loader={loader}
                        // agregar={cambio_buscador}
                        agregar={agregar}
                        quitar={quitar}
                        producto_actual={producto_actual}
                        setProductoActual={setProductoActual}
                    />
                    <div
                        style={{
                            borderRadius: "0",
                            padding: "4px 2px 2px 2px",
                            borderTop: "none",
                        }}
                        className="grid-container mt0"
                    >
                        <div
                            className="d-flex justify-content-around align-items-center padding-10 flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row"
                            style={{ backgroundColor: "#FFF" }}
                        >
                            {/* <button className="d-lg-none d-xl-none btn btn-outline-primary" type="button" onClick={() => {cambio_buscador()}}>Agregar Producto</button> */}
                            <div className="align-items-center mt0 padding-10 d-flex justify-content-around flex-row flex-sm-row flex-md-row flex-lg-row flex-xl-row">
                                <Link
                                    className="btn btn-tertiary mr-1"
                                    to={"/bodega"}
                                >
                                    <img src={icons.cancelar} alt="" />
                                    Cancelar
                                </Link>
                                <button
                                    disabled={loader}
                                    className="btn btn-primary mr-1"
                                    type="submit"
                                >
                                    <i className="fa fa-check mr"></i>
                                    Finalizar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

const ReajusteForm = reduxForm({
    // a unique name for the form
    form: "Reajuste",
    validate: (data) => {
        return validate(data, {
            motivo: validators.exists()("Campo requerido"),
        });
    },
})(Form);

export default ReajusteForm;
